import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { ContactField } from '../../../models/contactField.model';
import { eDDField, eFeatures, eUserRole } from '../../../models/enum.model';
import { IntDropDownItem, IntDropDownItemListResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { ClassCodeService } from '../../../services/classCode.service';
import { ContactService } from '../../../services/contact.service';
import { GlobalService } from '../../../services/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-class-lookup',
    templateUrl: './class-lookup.component.html',
    styleUrl: './class-lookup.component.css'
})
export class ClassLookupComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    private intervals = new Set<ReturnType<typeof setInterval>>();

    encryptedUser: string = '';
    userResponse: UserResponse;
    user: CLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    classCode: number = 0;
    classCodes: IntDropDownItem[];
    classCodeLabel: string = '';
    contactFields: ContactField;
    classCodeTitle: string;

    constructor(public _localService: LocalService, public _contactService: ContactService, public _classCodeService: ClassCodeService, private _utilityService: UtilityService,
        public _globalService: GlobalService, private _router: Router, private route: ActivatedRoute
    ) {
        this._localService.isMenu = true;
    }

    ngOnInit() {

        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async (params) => {
                            if (params?.cls) {
                                this.classCode = +params?.cls;
                                await this.getContactFieldLoad();
                                this.classCodeLabel = `Class${this.classCode}Code`
                                this.loadClassCode(this.classCode);
                            }
                        })
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    loadClassCode(cls) {
        switch (cls) {
            case 1:
                this.getClassCode(eDDField.Class1Code);
                this.classCodeTitle = this.contactFields?.class1CodeTitle;
                break;
            case 2:
                this.getClassCode(eDDField.Class2Code);
                this.classCodeTitle = this.contactFields?.class2CodeTitle;
                break;
            case 3:
                this.getClassCode(eDDField.Class3Code);
                this.classCodeTitle = this.contactFields?.class3CodeTitle;
                break;
            case 4:
                this.getClassCode(eDDField.Class4Code);
                this.classCodeTitle = this.contactFields?.class4CodeTitle;
                break;
            case 5:
                this.getClassCode(eDDField.Class5Code);
                this.classCodeTitle = this.contactFields?.class5CodeTitle;
                break;
            case 6:
                this.getClassCode(eDDField.Class6Code);
                this.classCodeTitle = this.contactFields?.class6CodeTitle;
                break;
            case 7:
                this.getClassCode(eDDField.Class7Code);
                this.classCodeTitle = this.contactFields?.class7CodeTitle;
                break;
            case 8:
                this.getClassCode(eDDField.Class8Code);
                this.classCodeTitle = this.contactFields?.class8CodeTitle;
                break;
        }
    }


    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.ExcelUploadWizard)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("class-llokup.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getClassCode(classCodeNum) {
        await this._classCodeService.GetClassCodesDD(this.encryptedUser, classCodeNum, this.user?.cLPCompanyID)
            .then(async (result: IntDropDownItemListResponse) => {
                if (!isNullOrUndefined(result))
                    this.classCodes = UtilityService.clone(result?.intDropDownItemList);
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact.getLoadClass4Code", err.message, null,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContactFieldLoad() {
        await this._contactService.contactFieldLoad(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: ContactField) => {
                if (!isNullOrUndefined(result)) {
                    this.contactFields = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();

        this.intervals.forEach(id => clearInterval(id));
        this.intervals.clear();
    }
}
